const states: {
  [key: string]: string;
} = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District Of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

const provinces = {
  'Newfoundland and Labrador': 'NL',
  'Prince Edward Island': 'PE',
  'Nova Scotia': 'NS',
  'New Brunswick': 'NB',
  Quebec: 'QC',
  Ontario: 'ON',
  Manitoba: 'MB',
  Saskatchewan: 'SK',
  Alberta: 'AB',
  'British Columbia': 'BC',
  Yukon: 'YT',
  'Northwest Territories': 'NT',
  Nunavut: 'NU',
};

export const intentionSelectValues = {
  partner: 'Partner',
  workcenter: 'Workcenter',
  generateLeads: 'Generate Leads',
  quotes: 'Quotes',
  findSuppliers: 'Find Suppliers',
};

const intentionValues: any = {
  isRoleSupplier: [
    intentionSelectValues.partner,
    intentionSelectValues.workcenter,
    intentionSelectValues.generateLeads,
  ],
  isRoleBuyer: [
    intentionSelectValues.quotes,
    intentionSelectValues.findSuppliers,
  ],
};

export const getIntentionMappingForIntentionSelect = (
  intentionSelect: string
): string => {
  const intention = Object.keys(intentionValues).find((key) =>
    intentionValues[key].includes(intentionSelect)
  );
  return intention || '';
};

const processIdLabels = {
  '3d-printing': 'Plastic 3D Printing',
  'metal-3d-printing': 'Metal 3D Printing',
  'cnc-menu': 'CNC Machining',
  'sheet-cutting': 'Sheet Cutting',
  'sheet-metal': 'Sheet Metal',
  'tube-bending': 'Tube Bending',
  'tube-cutting': 'Tube Cutting',
  'die-casting': 'Die Casting',
  extrusion: 'Metal Extrusion',
  stamping: 'Metal Stamping',
  'injection-molding': 'Injection Molding',
  'plastic-extrusion': 'Plastic Extrusion',
  'urethane-casting': 'Urethane and Silicone Casting',
  other: 'Other Process',
};

const roleValues = {
  engineer: 'Engineer',
  engineerManagement: 'Engineering Management',
  designer: 'Designer',
  designManagement: 'Design Management',
  purchasing: 'Purchasing / Buyer / Finance',
  projectManagement: 'Program / Project Management',
  operations: 'Operations / MRO Management',
  leadership: 'Executive Leadership (CXO, VP, founder, etc.)',
  sales: 'Sales & Marketing',
  other: 'Other',
};

export const discoverySelectValues = {
  search: 'Online Search',
  social: 'Social Media',
  referral: 'Referral',
  xometryOutreach: 'Xometry Email or Outreach',
  thomas: 'Thomasnet',
  tradeshow: 'Industry Tradeshow or Event',
  podcast: 'Podcast or Industry Webinar',
  blog: 'Blog Post or Online Article',
  manufacturingAssociation: 'Manufacturing Association or Group',
  other: 'Other',
};

const poBoxPattern = new RegExp(/^\s*[p][.]*[o][.]*\s+[b][o][x]\s*/, 'i');
const shippingServices = ['DHL', 'FedEx', 'UPS', 'USPS'];
const shippingServiceOptions = shippingServices.map((service) => {
  return {
    value: service.toLocaleLowerCase(),
    label: service,
  };
});
export {
  poBoxPattern,
  provinces,
  states,
  intentionValues,
  roleValues,
  shippingServiceOptions,
  processIdLabels,
};
